import { render, staticRenderFns } from "./HistogramCompareChart.vue?vue&type=template&id=fdf58956"
import script from "./HistogramCompareChart.vue?vue&type=script&lang=js"
export * from "./HistogramCompareChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports